export const fncAuthorizeLogin = (state) => {
};

export const fncRequestCode = (state, payload) => {
	if( payload.length == 0 ) {
		state.codeError = true;
		state.requestSent  =false;
	} else {
		if( payload.length == 1 ) {
			state.loginId = payload[0].id;
			state.requestSent = false;
			state.hasResetRequest = true;
			state.hasCodeEmailed = true;
		} else {
			state.requestSent = false;
			state.hasResetRequest = true;
		}
	}
};

export const updateErrorStatus = (state) => {
	state.codeError = false;
};

export const updatehasResetRequest = (state) => {
	state.hasResetRequest = false;
};

export const fncResetPassword = (state, payload) => {
	if( payload.msg == 'Success' ) {
		state.resetSent = false;
		state.codeError = false;
		state.requestSent = false;
		state.hasCodeEmailed = false;
		setTimeout(function(){
			state.hasResetRequest = false;
			state.resetComplete = false;
			state.resetComplete = true;
			state.loginId = 0;
		}, 3000)
	} else {
		state.resetError = true;
		state.resetSent = false;
	}
};

export const fncGetAccountList = (state, payload) => {
	if( state.userAccountList.length == 0 ) {
		Object.keys(payload).forEach(function(key, index) {
			var manufacturer = payload[index].manufacturer_name;
			var pushManufacturer = { id: payload[index], text: manufacturer };
			state.userAccountList.push(pushManufacturer);
		});
	}
}

export const setTest = (state, payload) => {
	state.globalApp = payload;
};

export const fncSetTokenList = (state, payload) => {
  state.tokenList = payload;
};

export const fncEmptyTokens = (state, payload) => {
  state.tokenList = [];
};

export const fncSetAppUrl = (state, payload) => {
  state.appUrl = payload;
};

export const fncSetSetManufacturer = (state, payload) => {
  state.setManufacturer = payload;
};
